import axios from 'axios';
import { toast } from 'react-toastify';

import traceId from 'redux/traceId';
import { mapJussubSubscription } from './subscriptionJussubMapper';
import { mapJusbillSubscription } from './subscriptionJusbillMapper';

export const getSubscriptionV2 = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/v2/subscriptions`,
    { headers: { 'x-trace-id': traceId } },
  );

  return response.data;
};

const SUBSCRIPTION_MAPPERS_BY_PROVIDER = {
  jussub: mapJussubSubscription,
  jusbill: mapJusbillSubscription,
};

export const mapSubscriptionV2Response = (data) => {
  if (!data?.success) {
    return null;
  }

  const mapSubscription = SUBSCRIPTION_MAPPERS_BY_PROVIDER[data.provider];

  if (!mapSubscription) {
    console.error('Provider de assinatura não mapeado:', data.provider);
    toast.error('Não foi possível carregar os dados da sua assinatura.');
    return null;
  }

  return mapSubscription(data);
};
